import { wGroupIndicesATGeometry } from 'components/AgentTemplateEditView/menu/geometry';
import { IColumn } from 'components/general/types';
import EntityTableSegment from 'components/general/wizards/EntityTableSegment';
import { useActiveEntities } from 'hooks';
import { FieldOfViewVables, TFieldOfViewTypes } from 'utils/vable';
import FieldOfViewDialog from './FieldOfViewDialog';

const guidance = {
  heading: 'Create and Edit Fields of View',
  body: [
    {
      chunk:
        'Fields of View (FoVs) are defined based on a direction and either a circular or rectangular sensor plane. They are used in a simulation to direct and scope the sensor view. They are assigned to Sensors in the GNC edit board.',
    },
  ],
};

const columns: IColumn[] = [
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Type',
    render: (rowData) => FieldOfViewVables.Type[rowData.type as TFieldOfViewTypes].label,
  },
];

const FieldsOfViewSegment = () => {
  const { fieldsOfView } = useActiveEntities();

  return (
    <EntityTableSegment
      title="Fields of View"
      index={wGroupIndicesATGeometry.FOVS}
      guidance={guidance}
      entityColumns={columns}
      entityData={fieldsOfView}
      DialogComponent={FieldOfViewDialog}
      modelName="field of view"
    ></EntityTableSegment>
  );
};

export default FieldsOfViewSegment;
